// ANALYTICS - TRACKERS
import { init as initGLobal } from './../trackers/funnel/global-tracker';
import { init as initBasket } from './../trackers/funnel/basket-tracker';
import { init as initSaveLater } from './../trackers/funnel/savelater-tracker';
import { init as initDelivery } from './../trackers/funnel/delivery-tracker';
import { init as initPaymentTracker } from './../trackers/funnel/payment-tracker';
import { init as initCreation } from './../trackers/funnel/creation-tracker';
import { init as initLogin } from './../trackers/customer/login-tracker';
// SHOPPING TOOL
import { init as initStSaveLater } from './../shopping-tool/st-save-later';
import { init as initStModifyProduct } from './../shopping-tool/st-modify-product';
// ENHANCED E-COMMERCE
import { init as initEcImprBasket } from './../enhanced/ec-1-impression-basket';
import { init as initEcAddModifyProduct } from './../enhanced/ec-add-modifyproduct';
import { init as initEcRemoveFromCart } from './../enhanced/ec-5-remove-from-cart';
import { initCheckout as initEcClick } from './../enhanced/ec-2-click';

export const init = () => {
  if (window.cube.config.anly_useLegacy === 'Y') {
    // Initialisation des trackers
    if ($('body').is('.checkout, .checkout-login')) {
      initGLobal();
      initLogin();
    }
    if ($('.container').hasClass('create-account')) initCreation();
    if ($('body').hasClass('checkout-payment')) initPaymentTracker();
    if ($('body').hasClass('checkout-delivery')) initDelivery();
    if ($('body').hasClass('checkout')) {
      initBasket();
      initSaveLater();
    }

    // Init Shopping tools
    initStSaveLater();
    initStModifyProduct();

    // Init Enhanced e-Commerce
    initEcImprBasket();
    initEcAddModifyProduct();
    initEcRemoveFromCart();
    initEcClick();
  }
};



// WEBPACK FOOTER //
// ./src/analytics/routes/checkout.anly.route.js